import type { ReactNode } from 'react';
import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import Sticky from 'react-stickynode';
import { UnmountClosed } from 'react-collapse';
import { DropZone } from 'Components/frameworks/drop-zone/DropZone';
import { ProductCondensed } from 'Components/widgets/product-condensed/ProductCondensed';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer';
import { SearchCompareButton } from 'Components/widgets/facet-search-results/search-compare-button/SearchCompareButton';
type Props = {
  buttonLabel: string;
  cancelLabel: string;
  children?: ReactNode;
  className?: string;
  comparisonClick: () => void;
  comparisonToggle: () => void;
  comparisonUrl: string;
  dropzoneLabel?: string;
  isComparisonActive?: boolean;
  isComparisonSubmitable?: boolean;
  mandatoryMessage?: string;
  resultsCount?: number;
  selectedItems?: Array<any>;
  selectedItemsMax: number;
  toggleProductSelectedForComparison: ((arg0: string) => any) | null | undefined;
};
export const SearchCompareLarge = ({
  buttonLabel,
  cancelLabel,
  children,
  className,
  comparisonClick,
  comparisonToggle,
  comparisonUrl,
  dropzoneLabel,
  isComparisonActive,
  isComparisonSubmitable,
  mandatoryMessage,
  resultsCount,
  selectedItems = [],
  selectedItemsMax = 3,
  toggleProductSelectedForComparison,
}: Props) => {
  return (
    <Sticky
      bottomBoundary="#SearchCompareBeacon"
      innerActiveClass="border-b border-lightGrey"
      innerZ={3}
    >
      <section className={classnames('bg-white', className)}>
        <SiteContainer size="none" className="py-10">
          <div className="flex items-center justify-between gap-20">
            <div className="flex-1">{children}</div>
            {isComparisonActive && (
              <button className="text-14 font-bold" onClick={comparisonToggle} type="button">
                {cancelLabel}
              </button>
            )}
            <SearchCompareButton
              comparisonToggle={comparisonToggle}
              comparisonClick={comparisonClick}
              comparisonUrl={comparisonUrl}
              isComparisonActive={isComparisonActive}
              isComparisonDisabled={Boolean(!resultsCount || resultsCount === 0)}
              isComparisonSubmitable={isComparisonSubmitable}
              label={buttonLabel}
              mandatoryMessage={mandatoryMessage}
              selectedItemsCount={selectedItems.length}
              selectedItemsMax={selectedItemsMax}
            />
          </div>
        </SiteContainer>
        <UnmountClosed isOpened={isComparisonActive}>
          <div className="grid grid-cols-3 gap-20 p-20">
            {Array(selectedItemsMax)
              .fill()
              .map((_, idx) => {
                const product = selectedItems[idx];
                const productId = product && product.id;
                return (
                  <DropZone
                    className="h-full"
                    key={productId || idx}
                    label={dropzoneLabel}
                    number={idx + 1}
                    onClear={
                      productId && toggleProductSelectedForComparison
                        ? () => toggleProductSelectedForComparison(productId)
                        : undefined
                    }
                  >
                    {product && <ProductCondensed {...product} />}
                  </DropZone>
                );
              })}
          </div>
        </UnmountClosed>
      </section>
    </Sticky>
  );
};
